import React, { useEffect, useState } from 'react';
import { UploadedFile } from '../../index';

interface TxtViewerProps {
  file: UploadedFile;
  onError: (error: string) => void;
}

const TxtViewer: React.FC<TxtViewerProps> = ({ file, onError }) => {
  const [textContent, setTextContent] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTextContent = async () => {
      try {
        setIsLoading(true);
        onError('');

        // 读取文本文件内容
        const text = await file.file.text();
        setTextContent(text);
        
      } catch (error) {
        console.error('TXT加载失败:', error);
        onError('文本文件加载失败，请检查文件编码是否正确');
      } finally {
        setIsLoading(false);
      }
    };

    loadTextContent();
  }, [file, onError]);

  if (isLoading) {
    return (
      <div className="txt-viewer-loading">
        <div className="loading-spinner"></div>
        <p>正在读取文本文件...</p>
      </div>
    );
  }

  return (
    <div className="txt-viewer-container">
      <pre 
        className="txt-content"
        style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          border: '1px solid #e5e7eb',
          borderRadius: '8px',
          maxHeight: '600px',
          overflow: 'auto',
          fontFamily: 'Monaco, Consolas, "Courier New", monospace',
          fontSize: '14px',
          lineHeight: '1.5',
          whiteSpace: 'pre-wrap',
          wordWrap: 'break-word'
        }}
      >
        {textContent || '文件内容为空'}
      </pre>
    </div>
  );
};

export default TxtViewer;
